export const routeName = 'legal-disclaimer';
/** The archived site's words plus French, identical where the hosts overlap so switching keeps the URL. */
export const slugs: Record<string, string> = {
	es: 'aviso-legal',
	en: 'legal-disclaimer',
	ca: 'avis-legal',
	fr: 'mentions-legales',
	it: 'note-legali',
};
export const sitemap = { changefreq: 'yearly', priority: '0.3', lastmod: '2026-09-02' };
